import React, {useEffect, useLayoutEffect, useState} from 'react';
import {
    Accordion, AccordionBody,
    AccordionHeader,
    Button,
    Card,
    CardBody, Dialog, DialogBody, DialogFooter, DialogHeader,
    Input, Radio,
    Textarea,
    Typography
} from "@material-tailwind/react";
import InputMask from "react-input-mask";
import RoadSelect from "../../shared/road_select";
import NeighborhoodSelect from "../../shared/neighborhood_select";
import {NumericFormat} from "react-number-format";
import {CheckIcon} from "@heroicons/react/16/solid";
import MapComponentSearch from "../../shared/map_component_search";
import axios from "axios";

const LotSubtraction = ({lot, movement}) => {
    const bim = [1, 2, 3, 4, 5, 6];
    const currentYear = new Date().getFullYear() + 1;
    const years = Array.from({length: 21}, (_, i) => currentYear - 20 + i);

    const [error, setError] = useState(null);
    const [loaderActive, setLoaderActive] = useState(false);
    const [openEndDialog, setOpenEndDialog] = useState(false);
    const [newLot, setNewLot] = useState({
        parcel_code: '',
        location_type_id: 0,
        sector_id: 0,
        sector_name: '',
        block_id: 0,
        block_name: '',
        batch: '000',
        contributor_id: 0,
        new_contributor_id: null,
        road_id: 0,
        road_name: '',
        neighborhood_id: 0,
        neighborhood_name: '',
        ext_num: 0,
        int_num: null,
        address_references: null,
        inscription: '0',
        book: '0',
        folio: '0',
        effective_bimester: '1',
        effective_year: currentYear,
        start_exempt_bimester: '0',
        start_exempt_year: '0',
        end_exempt_bimester: '0',
        end_exempt_year: '0',
        notes: '',
        special_facilities_value: 0,
        special_facilities: null,
        reason_type_id: null,
    });
    const [assignedLands, setAssignedLands] = useState({});
    const [assignedConstructions, setAssignedConstructions] = useState({});
    const [rusticLandValues, setRusticLandValues] = useState([]);
    const [constValues, setConstValues] = useState([]);
    const [constDevaluations, setConstDevaluations] = useState([]);
    const [contributorValue, setContributorValue] = useState({
        name: "",
        parental_last_name: "",
        maternal_last_name: "",
        phone: "",
        rfc: "",
        contributor_type: "",
        street: "",
        ext_num: "",
        int_num: "",
        neighborhood: "",
        postal_code: "",
        notes: "",
    });
    const [nameContributor, setNameContributor] = useState("");
    const [pLastNameContributor, setPLastNameContributor] = useState("");
    const [mLastNameContributor, setMLastNameContributor] = useState("");
    const [contributorsResult, setContributorsResult] = useState([]);
    const [contributorExisted, setContributorExisted] = useState(false);
    const [openUserInfo, setOpenUserInfo] = useState(false);
    const [openNewUser, setOpenNewUser] = useState(false);
    const [openAccordion, setOpenAccordion] = useState(null);

    const getCSRFToken = () => {
        const token = document.querySelector('meta[name="csrf-token"]');
        return token ? token.content : "";
    };

    useLayoutEffect(() => {
        const [lotSector, block, batch] = lot.parcel_code.split('-');
        const sector = lotSector.substring(3);

        setNewLot((prev) => ({
            ...prev,
            parcel_code: lot.parcel_code,
            location_type_id: lot.location_type_id,
            sector_id: lot.sector_id,
            sector_name: sector,
            block_id: lot.block_id,
            block_name: block,
            batch: lot.batch,
            contributor_id: lot.contributor_id,
            road_id: lot.road_id,
            road_name: lot.road_name,
            neighborhood_id: lot.neighborhood_id,
            neighborhood_name: lot.neighborhood_name,
            reason_type_id: movement.id
        }));

        async function fetchData() {
            try {
                const [valuesResponse, devaluationsResponse] = await Promise.all([
                    fetch(`/construction_values.json`),
                    fetch(`/construction_devaluations.json`),
                ]);

                if (valuesResponse.ok) {
                    const constValuesData = await valuesResponse.json();
                    setConstValues(constValuesData);
                } else {
                    console.log("No se pudieron cargar valores de construcción.");
                }

                if (devaluationsResponse.ok) {
                    const devaluationsData = await devaluationsResponse.json();
                    setConstDevaluations(devaluationsData);

                } else {
                    console.log("No se pudieron cargar valores de devaluaciónes para construcciones.");
                }
            } catch (err) {
                console.error("Error al buscar el predio:", err);
            }
        }

        async function fetchLandValues() {
            try {
                const [rusticLandValResponse] = await Promise.all([
                    fetch(`/rustic_land_values.json`),
                ]);

                if (rusticLandValResponse.ok) {
                    const rustLandValData = await rusticLandValResponse.json();
                    setRusticLandValues(rustLandValData);
                } else {
                    console.log("No se pudieron cargar valores de predios rusticos.");
                }
            } catch (err) {
                console.error("Error al buscar el predio:", err);
            }
        }

        fetchData();

        if (lot.location_type_id === "1") {
            addLand();
        } else {
            fetchLandValues();
        }
    }, [lot]);

    const handleReset = () => {
        window.location.replace('movements');
    };

    const addLand = () => {
        const newKey = Date.now();

        setAssignedLands((prev) => ({
            ...prev,
            [newKey]: {
                current_area: 0,
                area: 0,
                land_type_id: lot.location_type_id,
                rustic_land_value_id: lot.location_type_id === "1" ? null : 0,
                new_land: true,
            },
        }));
    };

    const handleLandChange = (id, value) => {
        setAssignedLands((prev) => ({
            ...prev,
            [id]: {
                ...prev[id],
                current_area: value,
                area: value,
            },
        }));
    };

    const handleLandValueChange = (id, value) => {
        setAssignedLands((prev) => ({
            ...prev,
            [id]: {
                ...prev[id],
                rustic_land_value_id: value,
                area: prev[id].area,
            },
        }));
    };

    const addConstruction = () => {
        const newKey = Date.now();

        setAssignedConstructions((prev) => ({
            ...prev,
            [newKey]: {
                current_area: 0,
                area: 0,
                construction_devaluation_id: 0,
                construction_value_id: null,
                new_construction: true,
            },
        }));
    };

    const handleConstructionChange = (id, value) => {
        setAssignedConstructions((prev) => ({
            ...prev,
            [id]: {
                ...prev[id],
                current_area: value,
                area: value,
            },
        }));
    };

    const handleConstructionValueChange = (id, value) => {
        setAssignedConstructions((prev) => ({
            ...prev,
            [id]: {
                ...prev[id],
                construction_value_id: value,
                area: prev[id].area,
            },
        }));
    };

    const handleConstructionDevalChange = (id, value) => {
        setAssignedConstructions((prev) => ({
            ...prev,
            [id]: {
                ...prev[id],
                construction_devaluation_id: value,
                area: prev[id].area,
            },
        }));
    };

    const handleSearchContributor = async () => {
        setNewLot((prev) => ({
            ...prev,
            new_contributor_id: null,
        }));
        setContributorValue({
            name: "",
            parental_last_name: "",
            maternal_last_name: "",
            phone: "",
            rfc: "",
            contributor_type: "",
            street: "",
            ext_num: "",
            int_num: "",
            neighborhood: "",
            postal_code: "",
            notes: "",
        });
        setContributorExisted(false);
        setOpenAccordion(null);
        setOpenUserInfo(false);

        const response = await fetch(`/contributors/search_by_name?name=${nameContributor}&parental_last_name=${pLastNameContributor}&maternal_last_name=${mLastNameContributor}`);

        const data = await response.json();
        setContributorsResult(data);

        if (data.length === 0) {
            setContributorValue({
                name: nameContributor,
                parental_last_name: pLastNameContributor,
                maternal_last_name: mLastNameContributor,
                phone: "",
                rfc: "",
                contributor_type: "",
                street: "",
                ext_num: "",
                int_num: "",
                neighborhood: "",
                postal_code: "",
                notes: "",
            });
            setOpenNewUser(true);
        }
    }

    const handleOpenAccordion = (value) => setOpenAccordion(openAccordion === value ? 0 : value);

    const handleSelectContributor = (contributor) => {
        setOpenUserInfo(true);
        setContributorValue(contributor);
        setNewLot((prev) => ({
            ...prev,
            contributor_id: contributor.id,
        }));
        setContributorsResult([]);
        setContributorExisted(true);
    }

    const handleSubmit = async () => {
        setLoaderActive(true);
        const newLands = Object.entries(assignedLands)
            .filter(([_, data]) => data.new_land)
            .map(([id, data]) => ({
                area: data.area,
                land_type_id: data.land_type_id,
                rustic_land_value_id: data.rustic_land_value_id,
            }));

        const newConstructions = Object.entries(assignedConstructions)
            .filter(([_, data]) => data.new_construction)
            .map(([id, data]) => ({
                area: data.area,
                construction_devaluation_id: data.construction_devaluation_id,
                construction_value_id: data.construction_value_id,
            }));

        const params = {
            lot: newLot,
            new_lands: newLands,
            new_constructions: newConstructions,
            ...(!contributorExisted ? {contributor: contributorValue} : {})
        };

        try {
            const response = await axios.post(`lots/${lot.parcel_code}/subtraction.json`, {
                lot: newLot,
                new_lands: newLands,
                new_constructions: newConstructions,
                ...(!contributorExisted ? {contributor: contributorValue} : {})
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "X-CSRF-Token": getCSRFToken(),
                }
            });
            if (response.status === 200) {
                setOpenEndDialog(true);
                const current_lot_url = `/lots/${lot.parcel_code}/print_movement.pdf`;
                window.open(current_lot_url, '_blank');
            } else {
                setError('Error al actualizar dirección del predio. Verifica los datos.');
                setLoaderActive(false);
            }
        } catch (err) {
            setError('Error al guardar. Verifica los datos.');
            setLoaderActive(false);
        }
    };

    function Icon({id, open}) {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
            >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
            </svg>
        );
    }

    const totalArea = assignedLands ? Object.values(assignedLands).reduce((acc, land) => acc + Number(land.current_area || 0), 0) : 0;
    const totalConstruction = assignedConstructions ? Object.values(assignedConstructions).reduce((acc, construction) => acc + Number(construction.current_area || 0), 0) : 0;
    const getUnit = lot.location_type_id === "1" ? <>m<sup>2</sup></> : <>ha</>;

    return (
        <>
            <div className="flex-auto py-6 pt-0">
                <h6 className="font-semibold uppercase bg-blue-500 text-white p-2 rounded-t-lg">
                    Información nuevo predio
                </h6>
                <div className="flex flex-col lg:flex-row gap-4">
                    <div
                        className="flex-grow border border-blue-gray-100 p-4 rounded-t-none rounded-b-lg w-full lg:w-1/2 overflow-x-hidden">

                        <CardBody className='p-0'>
                            <div className='flex flex-col md:flex-row gap-4 w-full text-center'>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Clave catastral
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        {newLot.parcel_code}
                                    </Typography>
                                </div>
                            </div>
                            <div className='flex flex-col md:flex-row gap-4 w-full text-center'>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Tipo de predio
                                    </Typography>
                                    <Input value={newLot.location_type_id}
                                           readOnly={true}
                                           containerProps={{
                                               className: '!min-w-0 max-w-1/3'
                                           }}
                                           disabled={true}
                                           className='text-center'
                                    />
                                </div>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Sector
                                    </Typography>
                                    <Input value={newLot.sector_name}
                                           readOnly={true}
                                           containerProps={{
                                               className: '!min-w-0 max-w-1/3'
                                           }}
                                           disabled={true}
                                           className='text-center'
                                    />
                                </div>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Manzana
                                    </Typography>
                                    <Input value={newLot.block_name}
                                           readOnly={true}
                                           containerProps={{
                                               className: '!min-w-0 max-w-1/3'
                                           }}
                                           disabled={true}
                                           className='text-center'
                                    />
                                </div>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Lote
                                    </Typography>
                                    <Input value={newLot.batch}
                                           readOnly={true}
                                           containerProps={{
                                               className: '!min-w-0 max-w-1/3'
                                           }}
                                           disabled={true}
                                           className='text-center'
                                    />
                                </div>
                            </div>
                            <hr className="my-6 border-b-1 border-blue-gray-100"/>
                            <h6 className="text-blue-gray-600 text-sm text-center mt-3 mb-2 font-bold uppercase">
                                DIRECCIÓN
                            </h6>
                            <div className='flex flex-row gap-4'>
                                <div className="relative w-full mb-3">
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Calle
                                    </Typography>
                                    <RoadSelect
                                        value={
                                            newLot.road_id
                                                ? {
                                                    label: newLot.road_name,
                                                    value: newLot.road_id
                                                }
                                                : ''
                                        }
                                        onChange={(option) => {
                                            setNewLot((prev) => ({
                                                ...prev,
                                                road_id: option.value,
                                                road_name: option.label,
                                            }));
                                        }}
                                    />
                                </div>
                                <div className="relative w-full mb-3">
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Ext. num.
                                    </Typography>
                                    <Input value={newLot.ext_num}
                                           onChange={(e) => setNewLot({
                                               ...newLot,
                                               ext_num: e.target.value,
                                           })}
                                           containerProps={{
                                               className: '!min-w-0 max-w-1/3'
                                           }}
                                    />
                                </div>
                                <div className="relative w-full mb-3">
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Int. Num.
                                    </Typography>
                                    <Input value={newLot.num}
                                           onChange={(e) => setNewLot({
                                               ...newLot,
                                               num: e.target.value,
                                           })}
                                           containerProps={{
                                               className: '!min-w-0 max-w-1/3'
                                           }}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-row gap-4">
                                <div className="relative w-full mb-3">
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Colonia
                                    </Typography>
                                    <NeighborhoodSelect
                                        value={
                                            newLot.neighborhood_id
                                                ? {
                                                    label: newLot.neighborhood_name,
                                                    value: newLot.neighborhood_id
                                                }
                                                : ''
                                        }
                                        onChange={(option) => {
                                            setNewLot((prev) => ({
                                                ...prev,
                                                neighborhood_id: option.value,
                                                neighborhood_name: option.label,
                                            }));
                                        }}
                                    />

                                </div>
                                <div className="relative w-full mb-3">
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Referencia
                                    </Typography>
                                    <Input value={newLot.address_references}
                                           onChange={(e) => setNewLot({
                                               ...newLot,
                                               address_references: e.target.value,
                                           })}
                                           containerProps={{
                                               className: '!min-w-0 max-w-1/3'
                                           }}
                                    />
                                </div>
                            </div>
                            <hr className="my-6 border-b-1 border-blue-gray-100"/>
                            <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                                REGISTRO DEL PREDIO
                            </h6>
                            <div className="flex flex-wrap">
                                <div className="w-full lg:w-12/12 px-0">
                                    <div className="relative w-full mb-3">
                                        <div className='py-2'>
                                            <Typography
                                                variant="small"
                                                className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                            >
                                                R.P.P.
                                            </Typography>
                                            <div className='flex flex-row gap-4 w-full text-center'>
                                                <div className='flex flex-col w-full'>
                                                    <Input value={newLot.inscription}
                                                           onChange={(e) => setNewLot({
                                                               ...newLot,
                                                               inscription: e.target.value,
                                                           })}
                                                           containerProps={{
                                                               className: '!min-w-0 max-w-1/3'
                                                           }}
                                                           label='Insc.'
                                                    />
                                                </div>
                                                <div className='flex flex-col w-full'>
                                                    <Input value={newLot.folio}
                                                           onChange={(e) => setNewLot({
                                                               ...newLot,
                                                               folio: e.target.value,
                                                           })}
                                                           containerProps={{
                                                               className: '!min-w-0 max-w-1/3'
                                                           }}
                                                           label='Folio'
                                                    />
                                                </div>
                                                <div className='flex flex-col w-full'>
                                                    <Input value={newLot.book}
                                                           onChange={(e) => setNewLot({
                                                               ...newLot,
                                                               book: e.target.value,
                                                           })}
                                                           containerProps={{
                                                               className: '!min-w-0 max-w-1/3'
                                                           }}
                                                           label='Libro'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='py-2'>
                                            <Typography
                                                variant="small"
                                                className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                            >
                                                Fecha efecto
                                            </Typography>
                                            <div className='flex flex-row gap-4 w-full text-center'>
                                                <div className='flex flex-col w-full'>
                                                    <select
                                                        placeholder="Selecciona un bimestre"
                                                        className="rounded-[7px] border-blue-gray-200"
                                                        value={newLot.effective_bimester}
                                                        onChange={(e) => setNewLot((prev) => ({
                                                            ...prev,
                                                            effective_bimester: e.target.value
                                                        }))
                                                        }
                                                    >
                                                        {bim.map((bimester) => (
                                                            <option key={bimester} value={bimester.toString()}>
                                                                {bimester}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className='flex flex-col w-full'>
                                                    <select
                                                        placeholder="Selecciona un año"
                                                        className="rounded-[7px] border-blue-gray-200"
                                                        value={newLot.effective_year}
                                                        onChange={(e) => setNewLot((prev) => ({
                                                            ...prev,
                                                            effective_year: e.target.value
                                                        }))
                                                        }
                                                    >
                                                        {years.map((year) => (
                                                            <option key={year} value={year.toString()}>
                                                                {year}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='py-2'>
                                            <Typography
                                                variant="small"
                                                className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                                            >
                                                Fecha exento
                                            </Typography>
                                            <div className='flex flex-row gap-4 w-full text-center'>
                                                <div className='flex w-full gap-1'>
                                                    <Input value={newLot.start_exempt_bimester}
                                                           onChange={(e) => setNewLot({
                                                               ...newLot,
                                                               start_exempt_bimester: e.target.value,
                                                           })}
                                                           label={'Bim. inicio'}
                                                           containerProps={{
                                                               className: '!min-w-0 max-w-[50%]'
                                                           }}
                                                    />
                                                    <Input value={newLot.start_exempt_year}
                                                           onChange={(e) => setNewLot({
                                                               ...newLot,
                                                               start_exempt_year: e.target.value,
                                                           })}
                                                           label={'Año inicio'}
                                                           containerProps={{
                                                               className: '!min-w-0 max-w-[50%]'
                                                           }}
                                                    />
                                                </div>
                                                <div className='flex w-full gap-1'>
                                                    <Input value={newLot.end_exempt_bimester}
                                                           onChange={(e) => setNewLot({
                                                               ...newLot,
                                                               end_exempt_bimester: e.target.value,
                                                           })}
                                                           label={'Bim. fin'}
                                                           containerProps={{
                                                               className: '!min-w-0 max-w-[50%]'
                                                           }}
                                                    />
                                                    <Input value={newLot.end_exempt_year}
                                                           onChange={(e) => setNewLot({
                                                               ...newLot,
                                                               end_exempt_year: e.target.value,
                                                           })}
                                                           label={'Año fin'}
                                                           containerProps={{
                                                               className: '!min-w-0 max-w-[50%]'
                                                           }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-6 border-b-1 border-blue-gray-100"/>
                            <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                                TERRENO
                            </h6>
                            <div className="flex flex-wrap">
                                <div className="w-full lg:w-12/12 px-0">
                                    <div className="relative w-full mb-3">
                                        <Card className='w-full border-0' shadow={false}>
                                            <CardBody className='p-0'>
                                                {lot.location_type_id !== "1" && (
                                                    <div className='flex justify-end mb-3'>
                                                        <Button variant="filled"
                                                                onClick={addLand}
                                                                className="bg-indigo-500 px-2 py-2 rounded">
                                                            + Agregar terreno
                                                        </Button>
                                                    </div>
                                                )}
                                                <table className="w-full min-w-[640px] table-auto border">
                                                    <thead>
                                                    <tr className='bg-gray-50'>
                                                        {["Cve. Val.", "Área"].map(
                                                            (el) => (
                                                                <th
                                                                    key={el}
                                                                    className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                                >
                                                                    <Typography
                                                                        variant="small"
                                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                    >
                                                                        {el}
                                                                    </Typography>
                                                                </th>
                                                            )
                                                        )}
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {(!Object.entries(assignedLands) || Object.entries(assignedLands).length === 0) ? (
                                                        <tr className="w-full">
                                                            <td colSpan="100%" className="text-center py-3">
                                                                <strong>El predio no cuenta con terrenos
                                                                    registrados.</strong>
                                                            </td>
                                                        </tr>
                                                    ) : (Object.entries(assignedLands).map(([landId, data], index, array) => {
                                                            const className = `py-3 px-5 ${
                                                                index === array.length - 1 ? "" : "border-b border-blue-gray-50"
                                                            }`;
                                                            return (
                                                                <tr key={landId}
                                                                    className="hover:bg-gray-50 cursor-pointer">
                                                                    <td className={className}>
                                                                        {lot.location_type_id === "1" ? 'N/A - Terreno urbano' : (
                                                                            <select
                                                                                value={data.rustic_land_value_id}
                                                                                onChange={(e) => handleLandValueChange(landId, e.target.value)}
                                                                                className="w-full rounded-[7px] border-blue-gray-200"
                                                                                defaultValue="0"
                                                                            >
                                                                                <option key="0" value="0">SELECCIONA UN
                                                                                    TIPO
                                                                                </option>
                                                                                {rusticLandValues.map((rusticValue) => (
                                                                                    <option key={rusticValue.id}
                                                                                            value={rusticValue.id}>
                                                                                        {rusticValue.id} - {rusticValue.description}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        )}
                                                                    </td>
                                                                    <td className={className}>
                                                                        <Input
                                                                            value={data.current_area || 0.0}
                                                                            onChange={(e) => handleLandChange(landId, e.target.value)}
                                                                            containerProps={{className: '!min-w-0'}}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    )}
                                                    </tbody>
                                                    <tfoot>
                                                    <tr className='border-t'>
                                                        <td colSpan='1'
                                                            className='py-3 px-5 text-right border-r'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Totales
                                                            </Typography>
                                                        </td>
                                                        <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b'>
                                                            <NumericFormat
                                                                value={totalArea.toFixed(4)}
                                                                displayType={'text'}
                                                                allowLeadingZeros
                                                                thousandSeparator=","
                                                            /> {getUnit}
                                                        </td>
                                                    </tr>
                                                    </tfoot>
                                                </table>
                                            </CardBody>
                                        </Card>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-6 border-b-1 border-blue-gray-100"/>
                            <h6 className="text-blue-gray-600 text-sm mt-3 mb-6 font-bold uppercase">
                                CONSTRUCCIONES
                            </h6>
                            <div className="flex flex-wrap">
                                <div className="w-full lg:w-12/12 px-0">
                                    <div className="relative w-full mb-3">
                                        <Card className='w-full border-0' shadow={false}>
                                            <CardBody className='p-0'>
                                                <div className='flex justify-end mb-3'>
                                                    <Button variant="filled"
                                                            onClick={addConstruction}
                                                            className="bg-indigo-500 px-2 py-2 rounded">
                                                        + Agregar construcción
                                                    </Button>
                                                </div>
                                                <table className="w-full min-w-[640px] table-auto">
                                                    <thead>
                                                    <tr className='bg-gray-50'>
                                                        {["Cve. Valuación", "Edad", "Sup. Const."].map(
                                                            (el) => (
                                                                <th
                                                                    key={el}
                                                                    className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                                >
                                                                    <Typography
                                                                        variant="small"
                                                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                    >
                                                                        {el}
                                                                    </Typography>
                                                                </th>
                                                            )
                                                        )}
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {(!Object.entries(assignedConstructions) || Object.entries(assignedConstructions).length === 0) ? (
                                                        <tr className="w-full">
                                                            <td colSpan="100%" className="text-center py-3">
                                                                <strong>El predio no cuenta con
                                                                    construcciones.</strong>
                                                            </td>
                                                        </tr>
                                                    ) : (Object.entries(assignedConstructions).map(([constructionId, data], index, array) => {
                                                            const className = `py-3 px-5 ${
                                                                index === array.length - 1 ? "" : "border-b border-blue-gray-50"
                                                            }`;

                                                            return (
                                                                <tr key={constructionId}
                                                                    className="hover:bg-gray-50 cursor-pointer">
                                                                    <td className={className}>
                                                                        <select
                                                                            value={data.construction_value_id}
                                                                            onChange={(e) => handleConstructionValueChange(constructionId, e.target.value)}
                                                                            className="w-full rounded-[7px] border-blue-gray-200"
                                                                            defaultValue="0"
                                                                        >
                                                                            <option key="0" value="0">SELECCIONA UN
                                                                                TIPO
                                                                            </option>
                                                                            {constValues.map((constValue) => (
                                                                                <option key={constValue.id}
                                                                                        value={constValue.id}>
                                                                                    {constValue.id} - {constValue.description}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    </td>
                                                                    <td className={className}>
                                                                        <select
                                                                            value={data.construction_devaluation_id}
                                                                            onChange={(e) => handleConstructionDevalChange(constructionId, e.target.value)}
                                                                            className="w-full rounded-[7px] border-blue-gray-200"
                                                                            defaultValue="0"
                                                                        >
                                                                            {constDevaluations.map((constDevaluation) => (
                                                                                <option
                                                                                    key={constDevaluation.id}
                                                                                    value={constDevaluation.id}>
                                                                                    {constDevaluation.id}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    </td>
                                                                    <td className={className}>
                                                                        <Input
                                                                            name="current_area"
                                                                            value={data.current_area || 0}
                                                                            onChange={(e) => handleConstructionChange(constructionId, e.target.value)}
                                                                            containerProps={{className: "!min-w-0"}}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    )}

                                                    </tbody>
                                                    <tfoot>
                                                    <tr className='border-t'>
                                                        <td colSpan='2'
                                                            className='py-3 px-5 text-right border-r'>
                                                            <Typography
                                                                variant="small"
                                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                            >
                                                                Totales
                                                            </Typography>
                                                        </td>
                                                        <td className='py-3 px-5 cursor-pointer bg-gray-50 border-b'>
                                                            <NumericFormat
                                                                value={totalConstruction}
                                                                displayType={'text'}
                                                                thousandSeparator=","
                                                            /> m<sup>2</sup>
                                                        </td>
                                                    </tr>
                                                    </tfoot>
                                                </table>
                                                <div
                                                    className='flex flex-row gap-4 w-full mt-6 text-center border rounded-md bg-gray-50'>
                                                    <div
                                                        className='flex flex-col w-full p-4 place-content-center'>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Instalaciones especiales
                                                        </Typography>
                                                        <div
                                                            className="flex flex-row justify-center gap-1"
                                                        >
                                                            <span className='py-2'>$</span>
                                                            <Input value={newLot.special_facilities_value}
                                                                   onChange={(e) => setNewLot({
                                                                       ...newLot,
                                                                       special_facilities_value: e.target.value,
                                                                   })}
                                                                   containerProps={{
                                                                       className: '!min-w-0 max-w-[50%]'
                                                                   }}
                                                                   className='text-center bg-white'
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        className={`flex flex-col w-full p-4`}>
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            Descripción de instalaciones especiales
                                                        </Typography>
                                                        <div
                                                        >
                                                            <Textarea
                                                                type="text"
                                                                className="bg-white"
                                                                value={newLot.special_facilities}
                                                                onChange={(e) => setNewLot({
                                                                    ...newLot,
                                                                    special_facilities: e.target.value,
                                                                })}
                                                                rows="6"
                                                            ></Textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-6 border-b-1 border-blue-gray-100"/>
                            <h6 className="text-blue-gray-600 text-sm mt-3 mb-6 font-bold uppercase">
                                PROPIETARIO
                            </h6>
                            <div className="flex flex-wrap">
                                <div className='w-full'>
                                    <div
                                        className="w-full flex gap-y-4 flex-col">
                                        <div>
                                            <h6 className="text-blue-gray-600 text-sm mt-0 mb-2 font-bold uppercase">
                                                BUSQUEDA DE CONTRIBUYENTE
                                            </h6>
                                            <Typography
                                                variant="small"
                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                            >
                                                Ingresa los datos del nuevo contribuyente.
                                            </Typography>
                                        </div>
                                        <div className="flex flex-row w-full gap-2 items-center">
                                            <input
                                                type="text"
                                                placeholder="Nombre"
                                                className="p-2 w-full border border-gray-300 rounded uppercase"
                                                value={nameContributor}
                                                onChange={(e) => setNameContributor(e.target.value.toUpperCase())}
                                            />
                                            <input
                                                type="text"
                                                placeholder="Apellido Paterno"
                                                className="p-2 w-full border border-gray-300 rounded uppercase"
                                                value={pLastNameContributor}
                                                onChange={(e) => setPLastNameContributor(e.target.value.toUpperCase())}
                                            />
                                            <input
                                                type="text"
                                                placeholder="Apellido Materno"
                                                className="p-2 w-full border border-gray-300 rounded uppercase"
                                                value={mLastNameContributor}
                                                onChange={(e) => setMLastNameContributor(e.target.value.toUpperCase())}
                                            />
                                        </div>
                                        <div className="flex flex-row w-full gap-2 items-center">
                                            <Button
                                                onClick={handleSearchContributor}
                                                className='bg-indigo-500 hover:bg-indigo-600 w-full'
                                            >
                                                Buscar
                                            </Button>
                                        </div>
                                    </div>
                                    {contributorsResult.length > 0 && (
                                        <div className="mt-8 w-full">
                                            <hr className="my-6 w-full border-b-1 border-blue-gray-100"/>
                                            <h6 className="font-semibold uppercase text-gray-600 mb-0">
                                                Resultados de búsqueda
                                            </h6>

                                            <div className='border p-4 rounded-md bg-white shadow'>
                                                {contributorsResult.map((contributor, index) => (
                                                    <Accordion key={index}
                                                               open={openAccordion === contributor.id}
                                                               className="mb-0 border-b border-blue-gray-50 px-4 hover:bg-blue-gray-50"
                                                               icon={<Icon id={contributor.id}
                                                                           open={openAccordion}/>}

                                                    >
                                                        <AccordionHeader
                                                            onClick={() => {
                                                                handleOpenAccordion(contributor.id);
                                                            }}
                                                            className={`border-0 py-2 font-medium ${
                                                                openAccordion === contributor.id ? "text-indigo-500 hover:!text-indigo-600" : "text-gray-700"
                                                            }`}
                                                        >
                                                            <Typography className='font-bold'>
                                                                {contributor.name} {contributor.parental_last_name} {contributor.maternal_last_name}
                                                            </Typography>

                                                        </AccordionHeader>
                                                        <AccordionBody className="pt-0 text-base font-normal">
                                                            <table
                                                                className="w-full min-w-max table-auto text-left mb-2">
                                                                <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <Typography
                                                                            variant="small"
                                                                            color="blue-gray"
                                                                            className="font-bold"
                                                                        >
                                                                            Dirección:
                                                                        </Typography>
                                                                    </td>
                                                                    <td>
                                                                        <Typography
                                                                            variant="small"
                                                                            className="font-normal text-gray-600"
                                                                        >
                                                                            {contributor.street}
                                                                            {contributor.ext_num ? " #" + contributor.ext_num : ""}
                                                                            {contributor.neighborhood ? ', ' + contributor.neighborhood : ''}
                                                                            {contributor.postal_code ? ', C.P. ' + contributor.postal_code : ''}
                                                                        </Typography>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <Typography
                                                                            variant="small"
                                                                            color="blue-gray"
                                                                            className="font-bold"
                                                                        >
                                                                            Teléfono:
                                                                        </Typography>
                                                                    </td>
                                                                    <td>
                                                                        <Typography
                                                                            variant="small"
                                                                            className="font-normal text-gray-600"
                                                                        >
                                                                            {contributor.phone}
                                                                        </Typography>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <Typography
                                                                            variant="small"
                                                                            color="blue-gray"
                                                                            className="font-bold"
                                                                        >
                                                                            RFC:
                                                                        </Typography>
                                                                    </td>
                                                                    <td>
                                                                        <Typography
                                                                            variant="small"
                                                                            className="font-normal text-gray-600"
                                                                        >
                                                                            {contributor.rfc}
                                                                        </Typography>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <Typography
                                                                            variant="small"
                                                                            color="blue-gray"
                                                                            className="font-bold"
                                                                        >
                                                                            Tipo de contribuyente:
                                                                        </Typography>
                                                                    </td>
                                                                    <td>
                                                                        <Typography
                                                                            variant="small"
                                                                            className="font-normal text-gray-600"
                                                                        >
                                                                            {contributor.contributor_type === 'P' ? 'Persona física' : 'Persona moral'}
                                                                        </Typography>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>

                                                            <Button
                                                                className='w-full bg-green-500 hover:bg-green-600 flex items-center justify-center gap-3'
                                                                onClick={() => handleSelectContributor(contributor)}>
                                                                <CheckIcon className='h-5 w-5'/>
                                                                Seleccionar
                                                            </Button>
                                                        </AccordionBody>
                                                    </Accordion>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {openUserInfo ? (
                                        <>
                                            <hr className="my-6 w-full border-b-1 border-blue-gray-100"/>
                                            <h6 className="text-gray-500 w-full text-sm font-bold uppercase">
                                                Información del contribuyente
                                            </h6>
                                            <div className="flex flex-col lg:flex-row gap-4">
                                                <div
                                                    className="flex-grow border p-4 rounded-md w-full lg:w-1/2">
                                                    <table
                                                        className="w-full min-w-max table-auto text-left mb-2">
                                                        <tbody>
                                                        <tr>
                                                            <td>
                                                                <Typography
                                                                    variant="small"
                                                                    color="blue-gray"
                                                                    className="font-bold"
                                                                >
                                                                    Nombre:
                                                                </Typography>
                                                            </td>
                                                            <td>
                                                                <Typography
                                                                    variant="small"
                                                                    className="font-normal text-gray-600"
                                                                >
                                                                    {contributorValue.name} {contributorValue.parental_last_name} {contributorValue.maternal_last_name}
                                                                </Typography>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <Typography
                                                                    variant="small"
                                                                    color="blue-gray"
                                                                    className="font-bold"
                                                                >
                                                                    Dirección:
                                                                </Typography>
                                                            </td>
                                                            <td>
                                                                <Typography
                                                                    variant="small"
                                                                    className="font-normal text-gray-600"
                                                                >
                                                                    {contributorValue.street}
                                                                    {contributorValue.ext_num ? " #" + contributorValue.ext_num : ""}
                                                                    {contributorValue.neighborhood ? ', ' + contributorValue.neighborhood : ''}
                                                                    {contributorValue.postal_code ? ', C.P. ' + contributorValue.postal_code : ''}
                                                                </Typography>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <Typography
                                                                    variant="small"
                                                                    color="blue-gray"
                                                                    className="font-bold"
                                                                >
                                                                    Teléfono:
                                                                </Typography>
                                                            </td>
                                                            <td>
                                                                <Typography
                                                                    variant="small"
                                                                    className="font-normal text-gray-600"
                                                                >
                                                                    {contributorValue.phone}
                                                                </Typography>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <Typography
                                                                    variant="small"
                                                                    color="blue-gray"
                                                                    className="font-bold"
                                                                >
                                                                    RFC:
                                                                </Typography>
                                                            </td>
                                                            <td>
                                                                <Typography
                                                                    variant="small"
                                                                    className="font-normal text-gray-600"
                                                                >
                                                                    {contributorValue.rfc}
                                                                </Typography>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <Typography
                                                                    variant="small"
                                                                    color="blue-gray"
                                                                    className="font-bold"
                                                                >
                                                                    Tipo de contribuyente:
                                                                </Typography>
                                                            </td>
                                                            <td>
                                                                <Typography
                                                                    variant="small"
                                                                    className="font-normal text-gray-600"
                                                                >
                                                                    {contributorValue.contributor_type === 'P' ? 'Persona física' : 'Persona moral'}
                                                                </Typography>
                                                            </td>
                                                        </tr>
                                                        {contributorValue.notes && (
                                                            <tr>
                                                                <td>
                                                                    <Typography
                                                                        variant="small"
                                                                        color="blue-gray"
                                                                        className="font-bold"
                                                                    >
                                                                        Observaciones contribuyente:
                                                                    </Typography>
                                                                </td>
                                                                <td>
                                                                    <Typography
                                                                        variant="small"
                                                                        className="font-normal text-gray-600"
                                                                    >
                                                                        {contributorValue.notes}
                                                                    </Typography>
                                                                </td>
                                                            </tr>
                                                        )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </>
                                    ) : openNewUser ? (
                                        <>
                                            <hr className="my-6 w-full border-b-1"/>
                                            <h6 className="text-blue-gray-300 text-sm mt-3 mb-6 font-bold uppercase">
                                                INFORMACIÓN DEL CONTRIBUYENTE
                                            </h6>
                                            <div className="flex flex-col gap-4 px-4">
                                                <div className='flex flex-row gap-4'>
                                                    <div className="relative w-full mb-3">
                                                        <label
                                                            className="block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                            htmlFor="grid-password"
                                                        >
                                                            Nombre <span
                                                            className='text-red-500'>(Requerido)</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                            value={contributorValue.name ? contributorValue.name : ''}
                                                            onChange={(e) => setContributorValue({
                                                                ...contributorValue,
                                                                name: e.target.value.toUpperCase()
                                                            })}
                                                        />
                                                    </div>
                                                    <div className="relative w-full mb-3">
                                                        <label
                                                            className="block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                            htmlFor="grid-password"
                                                        >
                                                            Apellido Paterno <span
                                                            className='text-red-500'>(Requerido)</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                            value={contributorValue.parental_last_name ? contributorValue.parental_last_name : ''}
                                                            onChange={(e) => setContributorValue({
                                                                ...contributorValue,
                                                                parental_last_name: e.target.value.toUpperCase()
                                                            })}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="flex flex-row gap-4">
                                                    <div className="relative w-full mb-3">
                                                        <label
                                                            className="block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                            htmlFor="grid-password"
                                                        >
                                                            Apellido Materno <span
                                                            className='text-red-500'>(Requerido)</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                            value={contributorValue.maternal_last_name ? contributorValue.maternal_last_name : ''}
                                                            onChange={(e) => setContributorValue({
                                                                ...contributorValue,
                                                                maternal_last_name: e.target.value.toUpperCase()
                                                            })}
                                                        />
                                                    </div>
                                                    <div className="relative w-full mb-3">
                                                        <label
                                                            className="block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                            htmlFor="grid-password"
                                                        >
                                                            Teléfono
                                                        </label>
                                                        <input
                                                            type="phone"
                                                            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                            value={contributorValue.phone ? contributorValue.phone : ''}
                                                            onChange={(e) => setContributorValue({
                                                                ...contributorValue,
                                                                phone: e.target.value
                                                            })}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='flex flex-row gap-4'>
                                                    <div className="relative w-full mb-3">
                                                        <label
                                                            className="block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                            htmlFor="grid-password"
                                                        >
                                                            R.F.C
                                                        </label>
                                                        <InputMask
                                                            mask="aaaa999999***"
                                                            value={contributorValue.rfc ? contributorValue.rfc : ''}
                                                            onChange={(e) => setContributorValue({
                                                                ...contributorValue,
                                                                rfc: e.target.value.toUpperCase()
                                                            })}
                                                        >
                                                            {(inputProps) => (
                                                                <input
                                                                    {...inputProps}
                                                                    type="text"
                                                                    placeholder="ABCD950131XXX"
                                                                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                                />
                                                            )}
                                                        </InputMask>
                                                    </div>
                                                    <div className="relative w-full mb-3">
                                                        <label
                                                            className="block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                            htmlFor="grid-password"
                                                        >
                                                            Tipo de propietario <span
                                                            className='text-red-500'>(Requerido)</span>
                                                        </label>
                                                        <Radio name='contributor_type'
                                                               value='P'
                                                               label='Persona física'
                                                               onChange={(e) => setContributorValue({
                                                                   ...contributorValue,
                                                                   contributor_type: e.target.value.toUpperCase()
                                                               })}
                                                               color='indigo'
                                                        />
                                                        <Radio name='contributor_type'
                                                               value='E'
                                                               label='Persona Moral'
                                                               onChange={(e) => setContributorValue({
                                                                   ...contributorValue,
                                                                   contributor_type: e.target.value.toUpperCase()
                                                               })}
                                                               color='indigo'
                                                        />
                                                    </div>
                                                </div>
                                                <div className='flex flex-row gap-4'>
                                                    <div className="relative w-full mb-3">
                                                        <label
                                                            className="block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                            htmlFor="grid-password"
                                                        >
                                                            Observaciones contribuyente
                                                        </label>
                                                        <textarea
                                                            type="text"
                                                            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                            value={contributorValue.notes ? contributorValue.notes : ''}
                                                            onChange={(e) => setContributorValue({
                                                                ...contributorValue,
                                                                notes: e.target.value.toUpperCase()
                                                            })}
                                                            rows="4"
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr className="my-6 border-b-1"/>
                                            <h6 className="text-blue-gray-300 text-sm mt-3 mb-6 font-bold uppercase">
                                                DIRECCIÓN DEL CONTRIBUYENTE
                                            </h6>
                                            <div className="flex flex-col gap-4 px-4">
                                                <div className="flex flex-row gap-4">
                                                    <div
                                                        className="flex-grow rounded-md w-full lg:w-1/2 min-h-[350px]">
                                                        <MapComponentSearch changeData={(place) => {
                                                            setPlace(place);
                                                        }}/>
                                                    </div>
                                                </div>
                                                <div className='flex flex-row gap-4'>
                                                    <div className="relative w-full mb-3">
                                                        <label
                                                            className="block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                            htmlFor="grid-password"
                                                        >
                                                            Calle <span
                                                            className='text-red-500'>(Requerido)</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                            value={contributorValue.street ? contributorValue.street : ''}
                                                            onChange={(e) => setContributorValue({
                                                                ...contributorValue,
                                                                street: e.target.value.toUpperCase()
                                                            })}
                                                        />
                                                    </div>
                                                    <div className="relative w-full mb-3">
                                                        <label
                                                            className="block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                            htmlFor="grid-password"
                                                        >
                                                            Ext. num.
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                            value={contributorValue.ext_num ? contributorValue.ext_num : ''}
                                                            onChange={(e) => setContributorValue({
                                                                ...contributorValue,
                                                                ext_num: e.target.value
                                                            })}
                                                        />
                                                    </div>
                                                    <div className="relative w-full mb-3">
                                                        <label
                                                            className="block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                            htmlFor="grid-password"
                                                        >
                                                            Int. Num.
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                            value={contributorValue.int_num ? contributorValue.int_num : ''}
                                                            onChange={(e) => setContributorValue({
                                                                ...contributorValue,
                                                                int_num: e.target.value
                                                            })}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="flex flex-row gap-4">
                                                    <div className="relative w-full mb-3">
                                                        <label
                                                            className="block uppercase text-blue-gray-600 text-xs font-bold mb-2"
                                                            htmlFor="grid-password"
                                                        >
                                                            Colonia
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                            value={contributorValue.neighborhood ? contributorValue.neighborhood : ''}
                                                            onChange={(e) => setContributorValue({
                                                                ...contributorValue,
                                                                neighborhood: e.target.value.toUpperCase()
                                                            })}
                                                        />
                                                    </div>
                                                    <div className="relative w-full mb-3">
                                                        <label
                                                            className="block uppercase text-blue-gray-600 text-xs font-bold mb-2">
                                                            Código Postal
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                            value={contributorValue.postal_code ? contributorValue.postal_code : ''}
                                                            onChange={(e) => setContributorValue({
                                                                ...contributorValue,
                                                                postal_code: e.target.value
                                                            })}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </div>
                            <hr className="my-6 border-b-1 border-blue-gray-100"/>
                            <h6 className="text-blue-gray-600 text-sm mt-3 mb-2 font-bold uppercase">
                                OBSERVACIONES
                            </h6>
                            <div className="flex flex-wrap">
                                <div className="w-full lg:w-12/12 px-0">
                                    <div className='flex flex-row gap-4'>
                                        <div className="relative w-full mb-3">
                                            <Typography
                                                variant="small"
                                                className="text-[11px] font-medium uppercase text-blue-gray-400"
                                            >
                                                OBSERVACIONES NUEVO PREDIO
                                            </Typography>
                                            <textarea
                                                type="text"
                                                className="border-blue-gray-100 px-3 py-3 placeholder-blue-gray-300 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                value={newLot.notes}
                                                onChange={(e) => setNewLot({
                                                    ...newLot,
                                                    notes: e.target.value,
                                                })}
                                                rows="6"
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                        <Button
                            className="w-full bg-green-500 mt-4 hover:bg-green-600 text-white rounded-md px-5 py-3 font-semibold"
                            onClick={() => handleSubmit()}
                            disabled={loaderActive || !openNewUser && !openUserInfo}
                        >
                            GUARDAR
                        </Button>
                        {
                            error && <p style={{color: "red"}}>{error}</p>
                        }
                    </div>
                </div>
            </div>
            <Dialog open={openEndDialog} handler={setOpenEndDialog}>
                <DialogHeader>Guardado</DialogHeader>
                <DialogBody>
                    <Typography>
                        Se actualizo el predio
                    </Typography>
                </DialogBody>
                <DialogFooter>
                    <Button
                        className="bg-green-500 text-white"
                        onClick={() => handleReset()}
                    >
                        Finalizar
                    </Button>
                </DialogFooter>
            </Dialog>
        </>
    )
};

export default LotSubtraction;
